import React from 'react'
import EmployerDashboardNav from '../../employer/EmployerDashboardNav'
import PostAjobCard from '../../employer/PostAjobCard'
import { useLocation } from "react-router";
import Breadcrumb from '../../Breadcrumb';

const PostAJob = () => {
  const { state } = useLocation();
  const job = state?.job;
  const updateMode = state?.updateMode;

  return (
    <>
      <Breadcrumb
        title="Post A Job"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "Post A Job", active: true }
        ]}
      />
      <div className='user-profile py-120'>
        <div className='container'>
          <div className='row'>
            <EmployerDashboardNav />
            <PostAjobCard job={job} updateMode={updateMode} />
          </div>
        </div>
      </div>
    </>
  )
}

export default PostAJob
